import { useContext, useState } from "react";
import { t } from "i18next";
import { Card, Tab, Tabs } from "react-bootstrap";
import { useParams } from "react-router-dom";
import ProducerMainTab from "@main/producers/pages/ProducerMainTab";
import { ListActionProvider as AddressListActionProvider } from "@bloonde/location/addresses/actions/list/ListActionContext";
import { RemoveActionProvider as AddressRemoveActionProvider } from "@bloonde/location/addresses/actions/remove/RemoveActionContext";
import { CreateActionProvider as AddressCreateActionProvider } from "@bloonde/location/addresses/actions/create/CreateActionContext";
import { EditActionProvider as AddressEditActionProvider } from "@bloonde/location/addresses/actions/edit/EditActionContext";
import AddressesPage from "@bloonde/location/addresses/pages/AddressesPage";
import { DetailsActionProvider as InvoiceAccountDetailsActionProvider } from "@bloonde/billing/invoice-accounts/actions/details/DetailsActionContext";
import InvoiceAccountMainTab from "@bloonde/billing/invoice-accounts/components/InvoiceAccountMainTab2";

import { RemoveActionProvider as ProductRemoveActionProvider } from "@beeldit/ecommerce/products/actions/remove/RemoveActionContext";
import { CreateActionProvider as ProductCreateActionProvider } from "@beeldit/ecommerce/products/actions/create/CreateActionContext";
import { ListActionProvider as ProductListActionProvider } from "@beeldit/ecommerce/products/actions/list/ListActionContext";

import React from "react";
import ProducerProductsPage from "@beeldit/ecommerce/products/pages/ProducerProductsPage";
import { ListActionProvider as OrderListProvider } from "@beeldit/ecommerce/orders/actions/list/ListActionContext";
import { ChangeStatusActionProvider } from "@beeldit/ecommerce/orders/actions/change-status/ChangeStatusActionContext";
import OrdersPage from "@beeldit/ecommerce/orders/pages/OrdersPage";
import ProducerConfigurationTab from "./ProducerConfigurationTab";
import { DetailsActionProvider as PageDetailsActionProvider } from "@bloonde/cms/cms-pages/actions/details/DetailsActionContext";
import PageEditionPage from "@bloonde/cms/cms-pages/pages/PageEditionPage";
import { DetailsActionContext as ProducerDetailsActionContext } from "@main/producers/actions/details/DetailsActionContext";

function ProducerDashboardPage(props: any) {
  const { formDefaultValues } = props;

  let { producerId } = useParams();

  if (!producerId) {
    producerId = "0";
  }

  const addressesFilters = {
    addressable_id: producerId,
    addressable_type: "App\\Models\\Producer",
  };
  const invoiceAccountFormDefaultValues = {
    entity_id: producerId,
    entity_type: "App\\Models\\Producer",
  };

  const [mainDataTabLoaded, setMainDataTabLoaded] = useState(true);
  const [ordersTabLoaded, setOrdersTabLoaded] = useState(false);
  const [pageTabLoaded, setPageTabLoaded] = useState(false);

  const { element } = useContext(ProducerDetailsActionContext);

  const onSelect = (key: string) => {
    if (key === "main_data") {
      setMainDataTabLoaded(true);
    } else if (key === "orders") {
      setOrdersTabLoaded(true);
    } else if (key === "page") {
      setPageTabLoaded(true);
    }
  };

  return (
    <>
      <Tabs
        defaultActiveKey="main_data"
        id="uncontrolled-tab-example"
        className=""
        onSelect={(key: any) => {
          onSelect(key);
        }}
      >
        <Tab eventKey="main_data" title={t("main_data")}>
          {mainDataTabLoaded && (
            <ProducerMainTab
              producerId={producerId}
              formDefaultValues={formDefaultValues}
            />
          )}
        </Tab>
        <Tab eventKey="page" title={t("more_info")} disabled={!element?.id}>
          {pageTabLoaded && (
            <div className="mb-5">
              <PageDetailsActionProvider>
                <PageEditionPage
                  title={"page"}
                  propPageId={(element as any)?.page?.id}
                />
              </PageDetailsActionProvider>
            </div>
          )}
        </Tab>
        <Tab eventKey="addresses" title={t("shipping_addresses")}>
          <AddressListActionProvider>
            <AddressRemoveActionProvider>
              <AddressCreateActionProvider>
                <AddressEditActionProvider>
            <AddressesPage
              filters={addressesFilters}
              formDefaultValues={addressesFilters}
              maxItems={1}
            />
                </AddressEditActionProvider>
              </AddressCreateActionProvider>
            </AddressRemoveActionProvider>
          </AddressListActionProvider>
        </Tab>
        <Tab eventKey="invoice_account" title={t("invoice_account")}>
          <InvoiceAccountDetailsActionProvider>
            <InvoiceAccountMainTab
              formDefaultValues={invoiceAccountFormDefaultValues}
            />
          </InvoiceAccountDetailsActionProvider>
        </Tab>
        <Tab eventKey="products" title={t("products")}>
          <ProductListActionProvider>
            <ProductRemoveActionProvider>
              <ProductCreateActionProvider>
                <ProducerProductsPage
                  filters={{ producer_id: producerId }}
                  formDefaultValues={{ producer_id: producerId }}
                />
              </ProductCreateActionProvider>
            </ProductRemoveActionProvider>
          </ProductListActionProvider>
        </Tab>
        <Tab
          eventKey="orders"
          title={t("orders")}
          disabled={!producerId || producerId === "0"}
        >
          {ordersTabLoaded && (
            <Card>
              <Card.Body>
                <OrderListProvider>
                  <ChangeStatusActionProvider>
                    <OrdersPage
                      filters={{ producer_id: producerId as string }}
                    />
                  </ChangeStatusActionProvider>
                </OrderListProvider>
              </Card.Body>
            </Card>
          )}
        </Tab>
        <Tab eventKey="configuration" title={t("configuration_data")}>
          <ProducerConfigurationTab
            producerId={producerId}
            formDefaultValues={formDefaultValues}
          />
        </Tab>
      </Tabs>
    </>
  );
}

export default ProducerDashboardPage;
